<template>
  <div class="discussion">
    <textarea class ="texarea" placeholder="Leave a message here" ref="content" v-model="comment"> </textarea>
    <div class="loading" v-if="isLoading"><adx-loading-primary /></div>
    <button v-else class="btn-small secondary" @click="createDiscussion">Submit</button>
  </div>
</template>

<script>
import { parse } from 'path';
import { parseErrorGql } from '@/lib/error'
import { mapGetters } from 'vuex';
import LoadingPrimary from '@/components/Loading/Primary'
import Vue from 'vue'

export default {
  name: 'adx-discussion',
  components: {
    'adx-loading-primary': LoadingPrimary,
  },
  props: {

  },
  data() {
    return {
      id: null,
      comment: null,
      userName: null,
      discussionData: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      user: 'account',
      profile: 'profile'
    })
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
  },
  beforeMount() {
    this.id = this.$route.params.id
  },
  mounted() {
    localStorage.setItem('apollo-token', this.token)
    this.userName = this.profile.full_name
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busOrder(){
      const data = await  this.$apollo.query({
        query:require('@/graphql/bus/busOrderDetail.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: this.$route.params.id
        }
      })
      if (data.data){
        if (data.errors){
          this.handleError(data.errors)
        } else{
          const { busOrder } = await data.data
          if (busOrder) {
            await this.mapData(busOrder)
          }
        }
        this.isLoading = false
      }
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          this.count++
          if (this.count<3) {
            await this.busCampaign()
          } else{
            this.showNotification()
          } 
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    showNotification(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async mapData(busOrder){
      this.discussionData = await busOrder.discussions
            let result = []
            
            this.discussionData.map(discussions => {
              let date = new Date (discussions.createdAt)
              let replies = []
              discussions.replies.map(reply =>{
                let dateReply = new Date(reply.createdAt)
                replies.push({
                  'id'      : reply.id,
                  'label'   : this.userName,
                  'comment' : reply.comment,
                  'date'    : dateReply
                })
              } )
              result.push({
                'id'      : discussions.id,
                'comment' : discussions.comment ,
                'label'   : discussions.file_type ? discussions.file_type : this.userName ,
                'date'    : date,
                'bast'    : discussions.file_type == 'BAST uploaded' | discussions.file_type == 'bast'? busOrder.bast : [],
                'mockup'  : discussions.file_type == 'Mockup uploaded' | discussions.file_type == 'mockup'? busOrder.mockup : [],
                'replies' : replies,
                'creative_files' : discussions.file_type == 'Creative file uploaded' | discussions.file_type == 'creative_files'? busOrder.creative_files : [],
              })
            })
            this.discussionData = result
    },
    async createDiscussion(){
        if(this.comment){
          this.isLoading = true
          const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/discussionAdd.gql'),
            errorPolicy: 'all',
            variables:{
              input:{
                comment: this.comment,
                file_type: this.userName,
                order:{
                  id: parseInt(this.$route.params.id)
                },
                replies:[]
              },
            },
          });
          if (result.data){
            await this.busOrder()
            this.$emit('discussionEvent')
            Vue.$broker.$emit("createDiscussion")
            this.isLoading = false
            this.comment = null
            this.successNotif()
          } else {
            this.errorNotification()
          }
        }
      },
      successNotif() {
        this.$notify({
              group: 'saved',
              title: 'Success',
              text: 'Discussion Submited',
              type: 'success'
        });
      },
      errorNotification(){
        this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Discussion message failed!',
              type: 'warn'
        });
      }
    }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>

  
</style>